export const HOME = {
  emergentLink: "home-emergent-link",
};

export const NAV = {
  logo: "nav-logo",
  menuToggle: "nav-menu-toggle",
  menuDrawer: "nav-menu-drawer",
  menuLink: (id) => `nav-menu-link-${id}`,
  ctaContact: "nav-cta-contact",
};

export const HERO = {
  root: "hero-root",
  eyebrow: "hero-eyebrow",
  title: "hero-title",
  subtitle: "hero-subtitle",
  ctaPrimary: "hero-cta-primary",
  ctaSecondary: "hero-cta-secondary",
};

export const SERVICES = {
  root: "services-root",
  item: (i) => `services-item-${i}`,
};

export const WORKS = {
  root: "works-root",
  slide: (i) => `works-slide-${i}`,
  prev: "works-prev",
  next: "works-next",
};

export const CONTACT = {
  root: "contact-root",
  form: "contact-form",
  name: "contact-name",
  email: "contact-email",
  subject: "contact-subject",
  message: "contact-message",
  submit: "contact-submit",
};

export const FOOTER = {
  root: "footer-root",
};
